import React from "react"
import classNames from "classnames"
import Icon from "../Icon/Icon"
import {TaskCardItem} from "./types"

type TaskCardState = "default" | "hover" | "done" | "active"

interface TaskCardProps extends TaskCardItem {
	state?: TaskCardState
}

export function TaskCard({title, description, duration, state = "default", icon, onClick}: TaskCardProps) {
	const isDone = state === "done"

	return (
		<button className={classNames("task-card", state)} onClick={onClick}>
			<div className="task-details">
				<div className="task-icon">
					<Icon size={20} icon={isDone ? "approve-v-check-validation" : icon} />
				</div>
				<div className="task-content">
					<div className="task-text">
						<div className="task-title">
							<span>{title}</span>
							<Icon size={14} icon="arrow-right-chevron" />
						</div>
						<div className="task-description">{description}</div>
					</div>
					<div className="task-duration-container">
						<div className="task-duration">
							<Icon size={16} icon="clock--interface-essential" />
							<span>{duration}</span>
						</div>
					</div>
				</div>
			</div>
		</button>
	)
}
